<template>
  <section class="intro-section pt-5">
    <div class="container">
      <h2 class="text-white pb-5">Datas e Informações Importantes</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="intro-text-box text-box text-white period-inactive">
            <div class="top-meta">02/09 a 20/09/2019 - Inscrições</div>
            <h3>Inscrições Abertas!</h3>
            <p>
              Durante este período, poderão ser inscritos membros individuais ou
              equipes de no mínimo 2 membros. Vale ressaltar que a confirmação
              da incrição cada um dos membros da equipe se dará através da
              doação de 1KG de alimento não perecível. A coleta destes alimentos
              será feita na recepção do campus IFCE Aracatí e
              <strong>TODOS</strong>
              os alimentos arrecadados serão doados.
            </p>
            <router-link to="/local" class="read-more">
              Não sabe como chegar? Clique aqui!
              <img
                src="../../assets/img/icons/double-arrow.png"
                alt="#"
              />
            </router-link>
            <!-- <a href="#" class="read-more">
                Não sabe como chegar? Clique aqui!
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
            </a>-->
          </div>
        </div>
        <div class="col-md-4">
          <div class="intro-text-box text-box text-white period-inactive">
            <div class="top-meta">21/09 a 22/09/2019 - Formação dos Times</div>
            <h3>Hora de formar os Times</h3>
            <p>
              Durante este período ocorrerá a formação dos times. Essa fase é
              exclusiva para jogadores que se inscreveram individualmente ou
              equipes com menos de 5 jogadores. A organização criará um grupo do
              whatsapp para formar os time. A formação das equipes se dará pelos
              próprios jogadores (ou randomicamente, caso não haja um consenso).
              O processo de formação das equipes se dará entre os dias
              14.09.2019 a 20.09.2019.
            </p>
            <!-- <a href="#" class="read-more">
                Read More
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
            </a>-->
          </div>
        </div>
        <div class="col-md-4">
          <div class="intro-text-box text-box text-white period-inactive">
            <div class="top-meta">22/09/19 - Divulgação da Tabela e Times</div>
            <h3>Meu Time e Contra quem irei jogar.</h3>
            <p>
              Após a formação dos times ocorrerá a divulgação dos mesmos bem
              como a elaboração e divulgação da tabela oficial dos jogos do
              campeonato. A tabela irá dispor quais times irão se enfrentar.
              Será criado um grupo no whatsapp (também será enviado um email,
              mas o grupo possui mais agilidade) com os capitães para repassar
              informações mais detalhadas aos jogadores. Vale ressaltar que a
              primeira fase será online e os jogos serão feitos na plataforma da
              Gamers Club.
            </p>
            <a href="https://gamersclub.com.br" class="read-more">
              Não conhece a plataforma da GC?
              <img
                src="../../assets/img/icons/double-arrow.png"
                alt="#"
              />
            </a>
          </div>
        </div>

        <hr />

        <div class="col-md-4 pt-5">
          <div class="intro-text-box text-box text-white period-inactive">
            <div class="top-meta">23/09 a 20/10/2019 - Etapa Online</div>
            <h3>Finalmente! Hora de Jogar.</h3>
            <p>
              Durante este período, deverão ocorrer os jogos conforme
              apresentados na tabela do campeonato. Os confrontos irão ocorrer
              no formato MD1 e serão executados online, na plataforma da
              <a
                href="https://gamersclub.com.br"
              >Gamers Club</a>. É
              interessante que as equipes e jogadores que ainda não conhecem a
              plataforma, entrem previamente e se preparem para evitar atrasos
              na hora de criar a partida. Peguem o perfil de todos os
              companheiros e montem seus times na GC.
            </p>
            <!-- <a href="#" class="read-more">
                Não sabe como chegar? Clique aqui!
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
            </a>-->
          </div>
        </div>
        <div class="col-md-4 pt-5">
          <div class="intro-text-box text-box text-white">
            <div class="top-meta">26/10/2019 - Etapa Local</div>
            <h3>We Are The Champions, my Friends! Semifinal e Final</h3>
            <p>
              Finalmente chegamos ao último dia de campeonato. Neste dia,
              ocorrerá a semifinal e a final. Um detalhe importante que vale ser
              ressaltado é que, a semifinal e a final serão realizadas
              localmente no IFCE Campus Aracatí. A semifinal manterá o formato
              MD1, já a final será no formato MD3 onde o vencedor será aquele
              que acumular 2 vitórias de um total de 3 partidas.
            </p>
            <!-- <a href="#" class="read-more">
                Read More
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
            </a>-->
          </div>
        </div>
        <!-- <div class="col-md-4 pt-5"></div> -->
        <!-- <div class="col-md-4 pt-5">
            <div class="intro-text-box text-box text-white">
              <div class="top-meta">
                17.09.19 - Divulgação dos Times e da Tabela
              </div>
              <h3>Meu Time e Contra quem irei jogar.</h3>
              <p>Após a formação dos times ocorrerá a divulgação dos mesmos bem como a elaboração e divulgação da tabela oficial dos jogos do campeonato. A table irá dispor quais 
                times irão se enfrentar. Vale ressaltar que a primeira fase será online e os jogos serão feitos na plataforma da Gamers Club.</p>
              <a href="https://gamersclub.com.br" class="read-more">
                Não conhece a plataforma da GC?
                <img src="../assets/img/icons/double-arrow.png" alt="#" />
              </a>
            </div>
        </div>-->
      </div>
      <hr />
    </div>
  </section>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
a {
  color: #b01ba5 !important;
}

.period-active {
  border: 2px outset #b01ba5;
  border-radius: 3%;
  // background: rgba(53, 21, 86, 0.5) !important;
}

.period-inactive {
  p {
    color: #68647d8a;
  }
  h3 {
    color: #68647d8a;
  }
  .top-meta {
    color: #68647d8a;
  }
}
</style>
